import React, { Fragment } from 'react'
import {
  Typography,
  TypographyProps,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box
} from '@mui/material'
import WarehouseMultiSelect from '../../pages/ProductOrigin/Components/WarehouseMultiselect'
import { SelectedWarehousesByOperation } from '../../interfaces/Producto/ProductOrigins'
import { Warehouse } from '../../interfaces'
import { Loading } from '../UI'
import { TypeOperation } from '../../interfaces/TypeOperation/TypeOperation'

interface Props {
  typeOperations: TypeOperation[]
  warehouses: Warehouse[]
  selectedWarehousesByOperation: SelectedWarehousesByOperation[]
  handleSelectedWarehouses: (
    typeOperationId: number,
    newSelected: number[]
  ) => void
  isLoading?: boolean
  showHeader?: boolean
  headerText?: string
  headerVariant?: TypographyProps['variant']
}

export const TypeOperationWarehousesTable: React.FC<Props> = ({
  typeOperations,
  warehouses,
  selectedWarehousesByOperation,
  handleSelectedWarehouses,
  isLoading = false,
  showHeader = true,
  headerText = 'Según el tipo de almacenamiento seleccionado previamente, asigne almacenes a los tipos de operaciones:',
  headerVariant = 'subtitle1'
}) => {
  if (isLoading) {
    return (
      <Box display='flex' justifyContent='center' mt={2}>
        <Loading />
      </Box>
    )
  }

  return (
    <Fragment>
      {showHeader && (
        <Typography
          variant={headerVariant}
          style={{ marginLeft: 10, marginTop: 20 }}
        >
          {headerText}
        </Typography>
      )}

      <Paper variant='outlined' style={{ width: '100%', marginTop: 4 }}>
        <Table size='small' sx={{ '& .MuiTableCell-root': { py: 0.25 } }}>
          <TableHead>
            <TableRow>
              <TableCell>Tipo Operación</TableCell>
              <TableCell>Almacenes Asignados</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {typeOperations?.map((item) => (
              <TableRow key={item.typeOperationId}>
                <TableCell>{item.name}</TableCell>
                <TableCell>
                  <WarehouseMultiSelect
                    warehouses={warehouses || []}
                    selectedItems={
                      selectedWarehousesByOperation?.find(
                        (op) => op.typeOperationId === item.typeOperationId
                      )?.warehouseIds || []
                    }
                    setSelectedItems={(newSelected: number[]) =>
                      handleSelectedWarehouses(
                        item.typeOperationId,
                        newSelected
                      )
                    }
                    required={false}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Fragment>
  )
}
